/* eslint-disable import/prefer-default-export */
export const taskQueryKeys = {
  taskDetails: (id: string, config: any) => ["task", "details", id, config],
};
